<template xmlns="http://www.w3.org/1999/html">
    <div class="login-full-a" id="category">
        <div id="page-content-wrapper" class="admin-content-area">
            <div class="container-fluid xyz">
                <div class="page-name">
                    Draggable Wellness Slider Image List
                    <button type="submit" v-on:click.prevent="addWellnessSlider" class="btn btn-primary waves-effect pull-right">Add</button>
                </div>
                <!--page content-->
                <div class="admin-page-content">
                    <draggable v-model="imageList" v-on:change="changePosition()" class="drag-view">
                        <template v-for="(text, index) in imageList">
                            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                <!--<router-link class="btn edit-btn-vvg waves-effect" v-bind:to="{name: 'PlayVideos',params:{id:text.id}}">-->
                                <span class="btn edit-btn-vvg waves-effect">
                                    <router-link title='Edit Wellness Slider' v-bind:to="{name: 'UpdateWellnessSlider',params:{id:text.id}}">
                                        <img :src="text.image" :key="index" class="img-rounded"/>
                                    </router-link>
                                </span>
                                <!--</router-link>-->
                                <button class="btn btn-danger deleteMedia"  v-on:click.prevent="deleteWellnessSliderImage(text.id)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                            </div>
                        </template>
                    </draggable>
                </div>
                <!--page content-->
            </div>
            <app-backend-footer></app-backend-footer>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery';
    import draggable from 'vuedraggable';
    import BackendFooter from '@/components/backend/partials/Footer';
    import Vue from "vue";
    import SessioMixin from '../../../mixins/sessionmixin';
    import {HTTP} from '../../../http-common';
    var self;
    export default {
        name: 'List_Media',
        mixins: [SessioMixin],
        components: {
            draggable,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                imageList: [],
                imagePosition: [],
            }
        },
        computed: {

        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },

        mounted: function () {
            self.getImages();
        },

        methods: {
            addWellnessSlider() {
                self.$router.push('/backend/addwellnessslider');
            },
            deleteWellnessSliderImage: function (id) {
                //console.log(id);
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        delete: id,
                    }
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.delete("deletewellnesssliderimage", config)
                            .then(function (response) {
                                self.getImages();
                            })
                            .catch(function (err) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                }
                            });
                        self.$swal('Deleted', 'You successfully deleted the record(s).', 'success')
                    } else {
                        self.$swal('Cancelled', 'Your record(s) still intact', 'info')
                    }
                });
            },
            getImages() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                /*var fields = {
                 limit: 2,
                 };*/
                HTTP.post("getwelnesssliderimage", '', config)
                    .then(function (response) {
                        self.imageList = response.data.content;
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },
            changePosition() {
                var fields = {
                    imageList: self.imageList,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("changepositionwellnessslider", fields, config)
                    .then(function (response) {
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/wellnessslider/ListWellnessSlider.vue